import { render } from "./warningIcon.vue?vue&type=template&id=5f93085a"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/warningIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f93085a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f93085a', __exports__)) {
    api.reload('5f93085a', __exports__)
  }
  
  module.hot.accept("./warningIcon.vue?vue&type=template&id=5f93085a", () => {
    api.rerender('5f93085a', render)
  })

}


export default __exports__